import { createSelector } from '@reduxjs/toolkit';
import { RootState } from 'store';

const selectUserState = (state: RootState) => state.user;

export const selectUserData = createSelector([selectUserState], (user) => user.userData);

export const selectQualityOnboarding = createSelector([selectUserState], (user) => user.userData.qualityOnboarding);

export const selectUserOrganizations = createSelector(
    [selectUserState],
    (user) => user.userOrganizations || []
);
